import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForJobComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'headline',
    'division',
    'category',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'division',
      type: 'relation',
    },
    {
      property: 'category',
      type: 'relation',
    },
    {
      property: 'cmsLanguageId',
      type: 'translate-value',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
